import clsx from 'clsx';

export const section = clsx('py-20', 'px-6', 'bg-background', 'text-center');

export const title = clsx(
  'title',
  'text-[26px]',
  'md:text-3xl',
  'font-semibold',
  'md:mb-10',
  'mb-2',
  'text-title',
  'text-center'
);

export const container = clsx('max-w-6xl', 'mx-auto', 'relative');

export const arrow = clsx(
  'absolute',
  'top-1/2',
  '-translate-y-1/2',
  'z-10',
  'cursor-pointer',
  'select-none',
  'p-1',
  'transition-transform',
  'duration-300',
  'hover:scale-110'
);

export const leftArrow = clsx('left-6', 'md:left-4');

export const rightArrow = clsx('right-6', 'md:right-4');

export const image = clsx(
  'w-full',
  'object-contain',
  'rounded-2xl',
  'shadow-lg',
  'transition-all',
  'duration-500',
  'select-none',
  'draggable-none'
);

export const activeImage = clsx('blur-0', 'md:scale-100', 'scale-90');

export const inactiveImage = clsx(
  'blur-[1px]',
  'md:scale-90',
  'scale-75',
  'opacity-20'
);
